import { useRef } from 'react'

import helper from '@utils/helper';
import { formatPrettyValue } from '@utils/index';
export const useBuyForm = (params) => {
  const { marginBalance, isLimit, form, coinDetail, assetCoinDetail } = params;
  const maxAvblAndSpotAvblRef = useRef({
    maxAvbl: '--',
    spotAvbl: '--'
  })
  const getCoin = () => coinDetail?.coinCode?.split('_')?.[1] || '';

  // 买方向 最大可用
  const renderMaxAvbl = () => {
    let value = '--';
    if (typeof marginBalance?.()?.additional !== 'undefined') {
      const additional = marginBalance?.()?.additional < 0 ? 0 : marginBalance?.()?.additional;
      let price = coinDetail?.ask
      if (isLimit) {
        price = form.getFieldValue('price');
      }
      const num = Number(additional + marginBalance?.()?.unwindBuyQty * price)
      value = helper.formatFixNumString(num, coinDetail?.tradePrecision) || '--'
    }
    if (['USDT_USD', 'USDT_HKD'].includes(coinDetail?.coinCode)) {
      renderSpotAvbl();
      let spotAvbl = maxAvblAndSpotAvblRef.current.spotAvbl
      spotAvbl = spotAvbl === '--' ? 0 : spotAvbl
      value = Math.max(Number(spotAvbl), Number(value))
    }
    maxAvblAndSpotAvblRef.current.maxAvbl = value
    return `${formatPrettyValue(value)} ${getCoin()}`
  }

  // 买方向 现货余额
  const renderSpotAvbl = () => {
    let value = '--'
    if (typeof marginBalance?.()?.quoteAvailable === 'undefined') {
      maxAvblAndSpotAvblRef.current.spotAvbl = value
      return `${value} ${getCoin()}`
    }
    if (marginBalance?.()?.quoteAvailable > 0) {
      value = helper.formatFixNumString(marginBalance?.()?.quoteAvailable ?? 0, assetCoinDetail?.showKeepDecimalForCoin ?? 8)
      maxAvblAndSpotAvblRef.current.spotAvbl = value
      return `${formatPrettyValue(value)} ${getCoin()}`
    }
    maxAvblAndSpotAvblRef.current.spotAvbl = 0
    return `${0} ${getCoin()}`
  }

  // 买方向 预估借
  const renderEstimateBorrow = () => {
    let isRender = false;
    const marginSelected = form.getFieldValue('marginSelected');
    const orderTotal = form.getFieldValue('orderTotal');
    const quoteAvailable = marginBalance?.()?.quoteAvailable > 0 ? marginBalance?.()?.quoteAvailable : 0
    if (marginBalance?.()?.openMargin && marginSelected && orderTotal - quoteAvailable > 0) {
      isRender = true
    }

    let value = '--'
    const baseQty = form.getFieldValue('baseQty')
    if (orderTotal && baseQty) {
      value = 0
      if (orderTotal - quoteAvailable > 0) {
        value = helper.formatFixNumString(orderTotal - quoteAvailable, coinDetail?.tradePrecision)
      }
    }
    return {
      isRender,
      text: `${value} ${getCoin()}`
    }
  }
  return {
    renderMaxAvbl,
    renderSpotAvbl,
    renderEstimateBorrow,
    maxAvblAndSpotAvblRef
  }
}
